import React from "react"
import { Text, TextProps } from "../../vanilla"
import { DateUtils } from '../../utils/date-utils'
import { useBasketStore, useGlobalStore } from "../../store/hooks/useStore"
import { ShopperCustomers } from "commerce-api"

interface DeliveryTimeProps {
  startHour?: string
  endHour?: string
  textProps?: Omit<TextProps<'span'>, 'children'>
  dateTextProps?: Omit<TextProps<'span'>, 'children'>
  showDate?: boolean
  showTime?: boolean
  dayText?: string
  order?: ShopperCustomers.Order,
  /** Determines if date and time strings should be display on same line. Disabled by default. */
  showInline?: boolean,
  dateFormat?: string
  windowStartTime?: string
  windowEndTime?: string
}

export const DeliveryTimeAndDate = ({
  startHour,
  endHour,
  textProps,
  dateTextProps = textProps,
  showDate = false,
  showTime = true,
  dayText,
  order,
  showInline = false,
  dateFormat = 'do MMMM',
  windowStartTime,
  windowEndTime
}: DeliveryTimeProps) => {
  const { basket } = useBasketStore()
  const { isCustomSitePreferenceSet, getCustomSitePreferenceById, customSitePreferences } = useGlobalStore()
  let is12HourClock;


  (async function () {
      if (!isCustomSitePreferenceSet('showSlotTimesIn12HourClock')) {
        await getCustomSitePreferenceById('showSlotTimesIn12HourClock')
      }
      is12HourClock = (customSitePreferences['showSlotTimesIn12HourClock'] as boolean || false)
    }
  )()
  
  let deliveryTime, deliveryDate

  // Determine which c_windowStartTime to use
  const _windowStartTime = windowStartTime || order?.c_windowStartTime || basket?.c_windowStartTime || ''
  const _windowEndTime = windowEndTime || order?.c_windowEndTime || basket?.c_windowEndTime || ''

  if (startHour && endHour) {
    // Use the props for the time range if provided, and convert if the 12H pref is true
    deliveryTime = is12HourClock ? `${DateUtils.convertTo12h(startHour)} - ${DateUtils.convertTo12h(endHour)}` : `${startHour} - ${endHour}`
  } 
  if (showDate && _windowStartTime && _windowEndTime) {
    // Use the order/basket/window props and formatDeliveryDate, passing in the 12H pref
    const [, dateOnly] = DateUtils.formatDeliveryDate(_windowStartTime, _windowEndTime, dateFormat, is12HourClock) || []
    deliveryDate = dateOnly
  }
  if (!startHour && !endHour && _windowStartTime && _windowEndTime && showTime) {
  // Fallback for when there is no time range provided, but a time is needed
  [deliveryTime, deliveryDate] = DateUtils.formatDeliveryDate(_windowStartTime, _windowEndTime, dateFormat, is12HourClock) || []
}

  // Coalesce provided day text and delivery date if present and required. 
  const dateText = `${dayText || ''} ${showDate && deliveryDate ? deliveryDate : ''}`.trim()

  return (
    <>
      <Text data-test-selector="delivery-date-time-section" {...textProps} >
          {/* Show the delivery time if present */}
          {deliveryTime && <>{deliveryTime}</>}
          {/* When both deliveryTime and dateText are present, seperate text with comma and line break */}
          {deliveryTime && dateText && <>, {!showInline && <br />}</> }
          {/* Show the dateText if present  */}
          {dateText && <Text as="span" {...dateTextProps}>{dateText} </Text>}
        </Text>
    </>
  )
}
